import React from 'react';
import { CHARACTER_IDS } from '../types/magical';
import { getCharacterColors } from '../types/characterColors';

const MagicalStats = ({ toolData, currentLap }) => {
  const getCurrentLapStats = () => {
    const suikaToCzRate = currentLap.suikaCount > 0 ? 
      ((currentLap.czCount / currentLap.suikaCount) * 100).toFixed(1) : '0.0';
    
    const totalEyeCatch = CHARACTER_IDS.reduce((sum, charId) => 
      sum + currentLap.eyeCatches[charId].strong + currentLap.eyeCatches[charId].weak, 0);

    return { suikaToCzRate, totalEyeCatch };
  };

  const getTotalStats = () => {
    // 除外フラグが立っていないラップのみを統計に含める
    const validLaps = toolData.laps.filter(lap => !lap.excludeFromStats);
    const totalSuikaCount = validLaps.reduce((sum, lap) => sum + lap.suikaCount, 0) + currentLap.suikaCount;
    const totalCzCount = validLaps.reduce((sum, lap) => sum + lap.czCount, 0) + currentLap.czCount;
    
    const totalRate = totalSuikaCount > 0 ? 
      ((totalCzCount / totalSuikaCount) * 100).toFixed(1) : '0.0';
    
    return { totalRate, totalSuikaCount, totalCzCount };
  };

  const getAllEyeCatchStats = () => {
    // 現ラップのアイキャッチ統計
    const currentTotalEyeCatch = CHARACTER_IDS.reduce((sum, charId) => 
      sum + currentLap.eyeCatches[charId].strong + currentLap.eyeCatches[charId].weak, 0);

    return { currentTotalEyeCatch };
  };

  const { suikaToCzRate } = getCurrentLapStats();
  const { totalRate, totalSuikaCount, totalCzCount } = getTotalStats();
  const { currentTotalEyeCatch } = getAllEyeCatchStats();

  return (
    <div className="space-y-4">
      {/* スイカCZ確率 */}
      <div className="bg-white rounded-lg shadow-md p-4">
        <h2 className="text-lg font-bold mb-3">スイカCZ確率</h2>
        <div className="grid grid-cols-2 gap-4">
          <div className="text-center p-3 bg-blue-50 rounded">
            <div className="text-sm text-gray-600">現ラップ</div>
            <div className="text-xl font-bold text-blue-700">{suikaToCzRate}%</div>
            <div className="text-xs text-gray-500">{currentLap.czCount}/{currentLap.suikaCount}</div>
          </div>
          <div className="text-center p-3 bg-green-50 rounded">
            <div className="text-sm text-gray-600">全体</div>
            <div className="text-xl font-bold text-green-700">{totalRate}%</div>
            <div className="text-xs text-gray-500">{totalCzCount}/{totalSuikaCount}</div>
          </div>
        </div>
      </div>
      

      {/* アイキャッチ出現率 */}
      <div className="bg-white rounded-lg shadow-md p-4">
        <div className="flex justify-between items-center mb-3">
          <h2 className="text-lg font-bold">アイキャッチ出現率</h2>
          <div className="text-sm text-gray-600">
            強出現率: <span className="font-bold text-red-600">
              {(() => {
                const totalEyeCatch = CHARACTER_IDS.reduce((sum, charId) => 
                  sum + currentLap.eyeCatches[charId].strong + currentLap.eyeCatches[charId].weak, 0);
                const totalStrong = CHARACTER_IDS.reduce((sum, charId) => 
                  sum + currentLap.eyeCatches[charId].strong, 0);
                return totalEyeCatch > 0 ? ((totalStrong / totalEyeCatch) * 100).toFixed(1) : '0.0';
              })()}%
            </span>
          </div>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
          {CHARACTER_IDS.map(charId => {
            const colors = getCharacterColors(charId);
            const strongCount = currentLap.eyeCatches[charId].strong;
            const weakCount = currentLap.eyeCatches[charId].weak;
            const totalCount = strongCount + weakCount;
            const strongRate = currentTotalEyeCatch > 0 ? ((strongCount / currentTotalEyeCatch) * 100).toFixed(1) : '0.0';
            const weakRate = currentTotalEyeCatch > 0 ? ((weakCount / currentTotalEyeCatch) * 100).toFixed(1) : '0.0';
            const totalRate = currentTotalEyeCatch > 0 ? ((totalCount / currentTotalEyeCatch) * 100).toFixed(1) : '0.0';

            return (
              <div key={charId} className={`${colors.background} ${colors.border} border rounded p-2`}>
                <h3 className={`font-medium mb-1 text-center text-xs ${colors.text.replace('text-white', 'text-gray-800')}`}>{colors.name}</h3>
                <div className="space-y-1 text-xs">
                  <div className="flex justify-between">
                    <span>強:</span>
                    <span className="font-bold">{strongCount} ({strongRate}%)</span>
                  </div>
                  <div className="flex justify-between">
                    <span>弱:</span>
                    <span className="font-bold">{weakCount} ({weakRate}%)</span>
                  </div>
                  <div className="flex justify-between font-bold border-t pt-1 text-gray-800">
                    <span>計:</span>
                    <span>{totalCount} ({totalRate}%)</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

    </div>
  );
};

export default MagicalStats;